module.exports = __webpack_public_path__ + "img/1_015.350d2d2d.jpg";